import { Inject, Injectable, inject } from '@angular/core';
import {
  ProductListByIdsConfigService,
  ProductService,
  AuthService,
  Product,
  ProductSortService,
  GungFlowService,
  MetadataService,
  AssortmentService,
  CloudPimFiltersService,
  CurrentAssortmentService,
  NavigationConfig
} from 'gung-standard';
import { ColmecProductListConfigService } from './colmec-product-list-config.service';
import { ListLayout } from 'gung-list';
import { GungImageUrlService } from 'gung-common';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class ColmecProductListByIdsConfigService extends ProductListByIdsConfigService {  protected productListConfigService = inject(ColmecProductListConfigService);

  getLayouts(): ListLayout<Product>[] {
    const gridLayout = this.productListConfigService.getLayouts().find(layout => layout.getName() === 'ProductGrid');

    if (gridLayout) {
      return [gridLayout];
    }

    return this.productListConfigService.getLayouts();
  }
}
